import { AuthBindings } from '@refinedev/core';
import { signInWithPopup, signOut } from 'firebase/auth';
import { auth, provider } from './firebase';

export const authProvider: AuthBindings = {
  login: async () => {
    try {
      await signInWithPopup(auth, provider);

      return {
        success: true,
        redirectTo: '/',
      };
    } catch (error) {
      return {
        success: false,
      };
    }
  },
  logout: async () => {
    await signOut(auth);

    return {
      success: true,
      redirectTo: '/login',
    };
  },
  onError: async (error) => {
    console.error(error);
    return { error };
  },
  check: async () => {
    await auth.authStateReady();
    const user = auth.currentUser;

    if (user) {
      return {
        authenticated: true,
      };
    }

    return {
      authenticated: false,
      error: {
        message: 'Check failed',
        name: 'Token not found',
      },
      logout: true,
      redirectTo: '/login',
    };
  },
  getPermissions: async () => null,
  getIdentity: async () => {
    const user = auth.currentUser;

    if (user) {
      return {
        email: user.email,
        avatar: user.photoURL,
      };
    }

    return null;
  },
};
